import { render, staticRenderFns } from "./DiscountProgramStackModal.vue?vue&type=template&id=e8695a44"
import script from "./DiscountProgramStackModal.vue?vue&type=script&lang=js"
export * from "./DiscountProgramStackModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports